//import FolderSharedOutlinedIcon from '@mui/icons-material/FolderSharedOutlined';
import MarkChatReadIcon from '@mui/icons-material/MarkChatRead';
import { Badge, IconButton, Tooltip } from '@mui/material';
import { MenuItem, MenuItemStateProps } from '@src/components';
import { Features } from '@src/core/features';
import { getNavBarBadgeRolesByAction } from '@src/roles';
import { useTheme } from '@src/themes';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSessionContext } from '../authentication';
import { useProjectContext } from '../switch-project';
import { useInteractionContext } from './interaction.context';

type IconProps = {
  color: string;
  fontSize: number;
  total: number;
};

const Icon: FC<IconProps> = ({ color, fontSize, total }) => (
  <Badge badgeContent={total} color={'error'}>
    <MarkChatReadIcon
      sx={{
        color,
        fontSize,
      }}
    />
  </Badge>
);

type DeliveredResponseTodayMenuProps = MenuItemStateProps & {
  variant: 'default' | 'mobile';
};

const DeliveredResponseTodayMenu: FC<DeliveredResponseTodayMenuProps> = ({ variant, isMini }) => {
  const { COLORS } = useTheme();
  const { allowAccess } = useSessionContext();
  const { allowedFeature, customizations } = useProjectContext();
  const { deliveredResponseTodayTotal } = useInteractionContext();
  const navigate = useNavigate();

  const { deliveredResponseToday = {} } = customizations ?? {};
  const { title = 'Respostas Recebidas' } = deliveredResponseToday as any;

  if (
    !allowAccess(getNavBarBadgeRolesByAction(Features.DELIVERED_RESPONSE_TODAY)) ||
    !allowedFeature(Features.DELIVERED_RESPONSE_TODAY)
  ) {
    return <></>;
  }

  const handleClick = () => {
    navigate('/interaction/delivered-response-today', { replace: true });
  };

  if (variant === 'mobile') {
    return (
      <Tooltip title={title}>
        <IconButton size={'large'} onClick={handleClick} sx={{ opacity: deliveredResponseTodayTotal > 0 ? 1 : 0.5 }}>
          <Icon color={COLORS.primary.contrast} fontSize={28} total={deliveredResponseTodayTotal} />,
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <MenuItem
      isMini={isMini}
      item={{
        title,
        icon: (
          <Icon
            color={deliveredResponseTodayTotal > 0 ? COLORS.primary.main : COLORS.text.disabled}
            fontSize={24}
            total={deliveredResponseTodayTotal}
          />
        ),
        ignoreDefaultAvatarStyle: true,
      }}
      onClick={handleClick}
    />
  );
};

export { DeliveredResponseTodayMenu };
